export default __webpack_public_path__ + "static/media/Griefscale Harness.1339a2bc.jpg";